import { render, staticRenderFns } from "./RepresentmentResume.vue?vue&type=template&id=22c02d98"
import script from "./RepresentmentResume.vue?vue&type=script&lang=js"
export * from "./RepresentmentResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RepresentmentResume.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports